import React from 'react';
import LookupManager from './LookupManager';

const CurrentComponent = () => {
    return (
        <LookupManager
            title="Current"
            endpoint="current"
            placeholder="Current value"
            loadingLabel="Loading current values..."
            emptyLabel="No current values yet."
        />
    );
};

export default CurrentComponent;
